import type { Option } from "@/components/form-inputs/StackedLabelKeyValueDropdown.vue";

export enum CustomFieldDataType {
  TEXT = 0,
  NUMERIC,
  DATE,
  LIST,
  BOOLEAN,
}

export const DataTypeDropdownOptions: Option[] = [
  {
    display: "Text",
    value: CustomFieldDataType.TEXT,
  },
  {
    display: "Number",
    value: CustomFieldDataType.NUMERIC,
  },
  {
    display: "Date",
    value: CustomFieldDataType.DATE,
  },
  {
    display: "List",
    value: CustomFieldDataType.LIST,
  },
  {
    display: "Checkbox",
    value: CustomFieldDataType.BOOLEAN,
  },
];
